subscriptionForm.$inject = ['$rootScope', 'AppService', 'SubscriptionService', '$timeout', '$uibModal']

export default function subscriptionForm($rootScope, AppService, SubscriptionService, $timeout, $uibModal) {
  var directive = {
    restrict: 'E',
    replace: true,
    scope: {
      subscription: '=',
      currency: '='
    },
    link: function(scope, elem, attrs) {
      scope.$parent[attrs.property] = this
      this.isPristine = () => scope.subscriptionForm.$pristine

      scope.filePath = $rootScope.filePath
      AppService.getMediaPlacements().then(res => scope.mediaPlacements = res.data)
      SubscriptionService.getSubscriptions(sessionStorage.getItem('profileId')).then(res => scope.subscriptions = res.data)
      AppService.getRecurrencePatterns().then(res => scope.recurrencePatterns = res.data)

      scope.uploadMedias = function(files, placement, invalidFiles) {
        files.forEach((file, index) => {
          scope.uploadedFile = true
          $rootScope.$on('uploadProgress', (event, data) => scope.uploadProgress = data)

          AppService.uploadMedia(file).then(res => {
            var file = res.data

            scope.uploadProgress = 100.0
            $timeout(function() {
              scope.hideAlert('uploadedFile')
            }, 5000)

            if (!scope.subscription.medias) scope.subscription.medias = new Array()

            var media, originalMedia
            new Promise((resolve, reject) => {
              if (file.type.includes('video')) {
                AppService.getMediaById(file.attrs.mediaId).then(res => {
                  originalMedia = file
                  media = res.data
                  resolve()
                })
              } else {
                media = file
                resolve()
              }
            }).then(() => {
              var existingSubscriptionToMediasSamePlacement = scope.subscription.medias.filter(media => media.mediaPlacement.placement.toLowerCase() == placement)
              var mediaPlacement = scope.mediaPlacements.find(mediaPlacement => mediaPlacement.placement.toLowerCase() == placement)
              var newSubscriptionToMediaSamePlacement = {
                order: existingSubscriptionToMediasSamePlacement.length + 1,
                mediaId: file.id,
                mediaPlacementId: mediaPlacement.id,
                media: media,
                mediaPlacement: mediaPlacement
              }
              if (originalMedia) newSubscriptionToMediaSamePlacement.originalMedia = originalMedia
              scope.subscription.medias.push(newSubscriptionToMediaSamePlacement)
              if (existingSubscriptionToMediasSamePlacement.length === 1 && existingSubscriptionToMediasSamePlacement[0].mediaPlacement.isReplace) {
                var index = scope.subscription.medias.findIndex(media => media === existingSubscriptionToMediasSamePlacement[0], 1)
                scope.subscription.medias.splice(index, 1)
                newSubscriptionToMediaSamePlacement.order = newSubscriptionToMediaSamePlacement.order - 1
              }
            })
          })
        })
        invalidFiles.forEach((file, index) => {
          scope.invalidFile = true
          scope.file = file
          $timeout(function() {
            scope.hideAlert('invalidFile')
          }, 5000)
        })
      }
      scope.addExternalResource = function() {
        $uibModal.open({
          controller: 'ModalExternalResourceController',
          controllerAs: 'modalExternalResource',
          template: require('../../app/external-resource-modal-new.html')
        }).result.then(externalResource => {
          if (externalResource) {
            scope.subscription.externalResources.push(externalResource)
          }
        })
      }
      scope.removeMedia = function(media) {
        var index = scope.subscription.medias.findIndex(media2 => media2.id === media.id)
        scope.subscription.medias.splice(index, 1)
      }
      scope.hideAlert = function(alert) {
        scope[alert] = false
      }
    },
    template: require('./_form-subscription.html')
  }

  return directive
}